import script from "./Terminology.vue?vue&type=script&setup=true&lang=js"
export * from "./Terminology.vue?vue&type=script&setup=true&lang=js"

import "./Terminology.vue?vue&type=style&index=0&id=6ffa71b8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffa71b8"]])

export default __exports__